export class PlantRequest{
    plantId: number;
    isPlantHO?: boolean;
    zoneId?:number;
}